var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden"},[_c('mobile-navigation',{attrs:{"menu":_vm.menu,"show-book-now":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }